export const makeHref = (pathname: string, offer_id?: string) => {
  if (!offer_id) return pathname;
  try {
    return `${pathname}?offer_id=${offer_id}`;
  } catch {
    return pathname;
  }
};
